export const splitPictureGallery = (pictures, cols) => {
  //pictures est la liste des photos
  //Cols est le nombre de colonnes

  let gallery = [];

  for (let i = 0; i < cols; i++) {
    const obj = {
      id: i,
      height: 0,
      images: [],
    };
    gallery.push(obj);
  }

  pictures.forEach((elem) => {
    if (elem.dimensions) {
      const ratio = 1 / elem.dimensions.ratio;
      gallery.sort(function(a, b) {
        return a.height - b.height;
      });
      gallery[0].images.push(elem);
      gallery[0].height += ratio;
    } else {
      console.log("missing dimensions of picture");
    }
  });
  return gallery;
};
